export function capitalize(string) {
    return string
        ?.split(" ")
        ?.map(
            (word) => word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase()
        )
        ?.join(" ");
}

export const validateUsername = (username) => {
    const regex = /^[a-zA-Z0-9._%+-]+@deloitte\.com$/;
    return regex.test(username);
};

export const isTokenExpired = (token) => {
    if (!token) return true;
    const payload = JSON.parse(atob(token?.split(".")[1]));
    const expiry = payload.exp;
    const now = Math.floor(Date.now() / 1000);
    return now > expiry;
};

export const getUserName = () => {
    const getUserData = JSON.parse(sessionStorage.getItem("loginData"));
    const { username } = getUserData || "admin";
    return capitalize(username?.split("@")[0]);
};

export const findTabName = (tabName) => {
    if (tabName === "current_state_bpmn_specification") {
        return "bpmn_specification";
    } else if (tabName === "current_state_process_documentation") {
        return "process_documentation";
    } else {
        return tabName;
    }
};

export function getTableColumns(rows) {
    if (rows?.length > 0) {
        return Object?.keys(rows[0])
            ?.filter((item) => item !== "batch_id" && item !== "batch_result_id")
            ?.map((item) => ({
                field: item,
                header: capitalize(item?.replace(/_/g, " ")),
            }));
    }
    return [];
}

// Utility to group agents by agent_category
export function groupByCategory(list) {
    const groupingData = {};
    list.forEach((agent) => {
        const categoryAttr = agent.attributes?.find(
            (attr) => attr.attribute_name === "agent_category"
        );
        const categoryValue =
            categoryAttr?.attribute_value?.lookup_value ?? "Uncategorized";
        if (!groupingData[categoryValue]) {
            groupingData[categoryValue] = [];
        }
        groupingData[categoryValue].push(agent);
    });
    return groupingData;
}

export function groupByWorkflowCategory(data) {
    return data.reduce((acc, item) => {
        const category = item.workflow_category || "Uncategorized";
        if (!acc[category]) {
            acc[category] = [];
        }
        acc[category].push(item);
        return acc;
    }, {});
}
export function descriptionFun(content) {
    const description =
        content?.content_type && content?.file_description
            ? content.file_description
            //          .split("_")
            //          .join(" ")
            //          .replace(/\.[^/.]+$/, "")
            : "N/A";

    return description;
}

// // Utility to group BPA by bap_category
// export function groupByCategoryBpa(list) {
//   const groupingData = {};
//   list.forEach((agent) => {
//     const categoryAttr = agent.attributes?.find(
//       (attr) => attr.attribute_name === "agent_category"
//     );
//     const categoryValue =
//       categoryAttr?.attribute_value?.lookup_value ?? "Uncategorized";
//     if (!groupingData[categoryValue]) {
//       groupingData[categoryValue] = [];
//     }
//     groupingData[categoryValue].push(agent);
//   });
//   return groupingData;
// }
// export function  validateInput (value) {
//   const specialCharRegex = /[!@#$%^&*(),.?":{}|<>]/g;
//   return !specialCharRegex.test(value); // Returns true if no special characters are found
// };
export function validateNoSpecialCharacters(value) {
    // const regex = /^[a-zA-Z0-9\s]*$/; // Allows only letters, numbers, and spaces
    const regex = /^[a-zA-Z0-9\s,.;\?]*$/;
    return regex.test(value);
};

export const getWorkflowCatergories = (workflow) => {
    return workflow?.workflow_category?.split(',').map(category => ({
        lookup_name: 'workflow_category',
        lookup_value: category.trim()
    }));
}
export const getAgentCatergories = (agent) => {
    return agent?.agent_category?.split(',').map(category => ({
        lookup_name: 'agent_category',
        lookup_value: category.trim()
    }));
}

// Utility function to get attribute value by attribute name
export const getAttributeValueByName = (attributes, attributeName) => {
    const attribute = attributes?.find(attr => attr.attribute_name === attributeName);
    return attribute?.attribute_value;
};

export const capitalizeFirstLetter = (str) => {
  if (!str) {
    return "";
  }
  return str.charAt(0).toUpperCase() + str.slice(1);
}